module.exports = __webpack_public_path__ + "img/l.48ba7420.jpg";